import LampDinners from './LampDinners';

export default LampDinners;